import { render, staticRenderFns } from "./Classcate.vue?vue&type=template&id=237fb50a&scoped=true"
import script from "./Classcate.vue?vue&type=script&lang=js"
export * from "./Classcate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237fb50a",
  null
  
)

export default component.exports